import { booleanAttribute, ChangeDetectionStrategy, Component, input } from '@angular/core';

export type PillVariant = 'info' | 'success' | 'warning' | 'danger';

@Component({
    selector: 'app-pill',
    standalone: true,
    template: '<ng-content />',
    styleUrl: './pill.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[class.danger]': 'variant() === "danger"',
        '[class.disabled]': 'disabled()',
        '[class.info]': 'variant() === "info"',
        '[class.success]': 'variant() === "success"',
        '[class.warning]': 'variant() === "warning"',
    },
})
export class PillComponent {
    readonly disabled = input(false, { transform: booleanAttribute });
    readonly variant = input<PillVariant>('info');
}
